import request from '@/src/apis/axios';
import FaqDto from '@/src/models/FaqDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  GetFaqsRequestParams,
  GetFaqByIdRequestParams,
  PostFaqRequestBody,
  PutFaqByIdRequestBody,
} from './faq.dtos';

const URL = {
  faq: '/admin/faqs',
  faqDetail: '/admin/faqs/{id}',
  faqCategory: '/faqs/faq-category',
};
// FAQ 카테고리 리스트 조회
export const getFaqCategoriesAPI = async () => {
  const { data } = await request<ObjectResponse<Record<string, string>>>({
    method: 'get',
    url: URL.faqCategory,
  });

  return Object.values(data?.row || []);
};

// FAQ 리스트 조회
export const getFaqsAPI = async (
  requestParams: Partial<GetFaqsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<FaqDto>>({
    method: 'get',
    url: URL.faq,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(FaqDto, data.rows);

  return { rows, count: data.count };
};

// FAQ 상세 조회
export const getFaqByIdAPI = async (requestParams: GetFaqByIdRequestParams) => {
  const { id } = requestParams;

  const { data } = await request<ObjectResponse<FaqDto>>({
    method: 'get',
    url: URL.faqDetail.replace('{id}', String(id)),
  });

  return data.row;
};

// FAQ 생성
export const postFaqAPI = async (requestBody: PostFaqRequestBody) => {
  const { data } = await request<ObjectResponse<FaqDto>>({
    method: 'post',
    url: URL.faq,
    requestBody: { ...requestBody, serviceType: 'EARTH_APP' },
  });

  return plainToInstance(FaqDto, data.row);
};

// FAQ 수정
export const putFaqByIdAPI = async (requestBody: PutFaqByIdRequestBody) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<FaqDto>>({
    method: 'put',
    url: URL.faqDetail.replace('{id}', String(id)),
    requestBody: { ...rest, serviceType: 'EARTH_APP' },
  });

  return plainToInstance(FaqDto, data.row);
};
